import * as Sentry from "@sentry/react";

const useGetProvidersSummaryPDFFile = () => {
    return async (pdfURL) => {
        let response;
        try {
            response = await fetch(
                `${process.env.REACT_APP_API_URL.startsWith('https://') ? pdfURL.replace('http://', 'https://') : pdfURL}`,
                {
                    method: 'GET',
                    headers: {
                        'Access-Control-Request-Method': 'GET'
                    }
                },
            );
        } catch (error) {
            console.log(error);
            error.clientStatusMessage = {
                variant: 'danger',
                i18nKey: 'error.api-connection-timeout',
                source: `useGetFields - ${error.message}`
            }
            throw error;
        }

        let responseBlob 
        try {
            responseBlob = await response.blob();
        } catch (error) {
            console.log(error);
            error.clientStatusMessage = {
                variant: 'danger',
                i18nKey: 'error.api-bad-response',
                source: `${response.status} ${response.statusText}`
            }
            throw error;
        }

        if (response.status !== 200) {
            const error = new Error();
            if (response.status) {
                switch (response.status) {
                    case 400:
                    case 415:
                        error.clientStatusMessage = {
                            variant: 'danger',
                            i18nKey: 'error.client-bad-request',
                            source: `${response.status.toString()}`
                        }
                        Sentry.captureException(response);
                        break;
                    default:
                        error.clientStatusMessage = {
                            variant: 'danger',
                            i18nKey: 'error.api-bad-response',
                            source: `${response.status.toString()}`
                        }
                        Sentry.captureException(response);
                }
            }
            throw error;
        }
        
        return responseBlob;
    }
}

export default useGetProvidersSummaryPDFFile;
